'use client';

import {
    createContext,
    useContext,
    ReactNode,
    FunctionComponent,
    useState,
    useEffect,
    Context,
} from 'react';

interface DeviceContextType {
    width: number;
    height: number;
}

const DeviceContext: Context<DeviceContextType | undefined> = createContext<
    DeviceContextType | undefined
>(undefined);

export const DeviceProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
    const [width, setWidth] = useState<number>(
        typeof window !== 'undefined' ? window.innerWidth : 1024
    );
    const [height, setHeight] = useState<number>(
        typeof window !== 'undefined' ? window.innerHeight : 768
    );

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const handleResize = () => {
            setWidth(window.innerWidth);
            setHeight(window.innerHeight);
        };

        // 首次同步一次
        handleResize();

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return <DeviceContext.Provider value={{ width, height }}>{children}</DeviceContext.Provider>;
};

export const useDevice = () => {
    const context = useContext(DeviceContext);
    if (context === undefined) {
        throw new Error('useDevice must be used within a DeviceProvider');
    }
    return context;
};
